"use client";

import classNames from "classnames";
import Link from "next/link";
import { FC, useCallback } from "react";

import { useGetProfile } from "@/features/events/hooks/use-get-profile.hook";
import { Typography } from "@/shared/ui";
import LogoIcon from "@/svgs/haute-societe.svg";

import { TABS, TabValues } from "../../constants/tabs.constant";

import styles from "./header.module.scss";
import { CommonHeaderProps } from "./header.types";

const CommonHeader: FC<CommonHeaderProps> = ({ selectedTab, rightAddon, onDoubleClick }) => {
  const { data: user } = useGetProfile();

  const getLinkHref = useCallback(
    (tabValue: TabValues, url: string) => {
      if (tabValue === "event") {
        switch (user?.role) {
          case "alpha":
            return `${url}/rest`;
          case "muse":
            return `${url}/date-nights`;
        }
      }
      return url;
    },
    [user]
  );

  return (
    <header className={styles.commonHeader}>
      <LogoIcon className={styles.logo} />

      <div className={styles.tabs}>
        {TABS.map(({ label, value, url }) => (
          <Link key={value} href={getLinkHref(value, url)} onClick={() => value === selectedTab && onDoubleClick?.()}>
            <Typography semi variant="body" className={classNames(styles.typo, value === selectedTab && styles.active)}>
              {label}
            </Typography>
          </Link>
        ))}
      </div>

      <div className={classNames(styles.rightAddon, !rightAddon && styles.rightShift)}>{rightAddon}</div>
    </header>
  );
};

export { CommonHeader };
